import React, { useState } from 'react';
import marketIcon from '../assets/market_icon.png';
import MarketModal from './MarketModal';

export default function MarketButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 124,
          left: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={marketIcon} alt="Market" style={{ width: 70, height: 70 }} />
      </button>
      <MarketModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
